export const settings_users_en = {
  settings_users_title: "Users",
  settings_users_desc:
    "Manage your team by overseeing users, assigning roles, organizing teams, reviewing pending invitations, and managing access - all in one place to keep your organization secure and running smoothly.",

  settings_users_add_role: "add role",

  settings_users_add_team: "add team",
  settings_users_reinvite: "re-invite",
  new_user: "New user",
  settings_users_account_metrics_no_limit: "No Limit",
  account_metrics: "Account metrics",

  settings_users_new_form_email_address:
    "Enter email addresses [multiple comma-separated]",

  settings_users_new_form_sharing_rules:
    "Sharing Rules [select team to enable this field]",

  check_payment_order_summary: "Order summary:",
  add_discount_code: "Add discount code",

  sharing_rule_is_empty: "Sharing rule is empty",

  settings_users_new_form_user_access_configuration: "User access settings"
};

export const settings_users_zhHans = {
  settings_users_title: "用户",
  settings_users_desc:
    "通过集中管理用户、分配角色、组织团队、查看待处理邀请以及控制访问权限，轻松管理您的团队，保障组织安全高效运行。",

  settings_users_add_role: "添加角色",

  settings_users_add_team: "添加团队",
  settings_users_reinvite: "重新邀请",
  new_user: "新用户",
  settings_users_account_metrics_no_limit: "无限制",
  account_metrics: "账户指标",

  settings_users_new_form_email_address: "请输入邮箱地址（多个请用逗号分隔）",
  settings_users_new_form_sharing_rules: "共享规则（选择团队后可启用该字段）",

  check_payment_order_summary: "订单摘要:",
  add_discount_code: "添加折扣码",

  sharing_rule_is_empty: "共享规则为空",

  settings_users_new_form_user_access_configuration: "用户访问设置",
};

export const settings_users_zhHant = {
  settings_users_title: "用戶",
  settings_users_desc:
    "集中管理用戶、指派角色、組織團隊、查看待處理邀請以及管理存取權限，讓您的團隊管理更高效，確保組織安全順暢運作。",

  settings_users_add_role: "新增角色",

  settings_users_add_team: "新增團隊",
  settings_users_reinvite: "重新邀請",
  new_user: "新用戶",
  settings_users_account_metrics_no_limit: "無限制",
  account_metrics: "帳戶指標",

  settings_users_new_form_email_address:
    "請輸入電子郵件地址（多個請用逗號分隔）",
  settings_users_new_form_sharing_rules: "共享規則（選擇團隊後可啟用此欄位）",

  check_payment_order_summary: "訂單摘要:",
  add_discount_code: "新增折扣碼",

  sharing_rule_is_empty: "共用規則為空",

  settings_users_new_form_user_access_configuration: "用戶存取設定",
};

// Japanese (日本語)
export const settings_users_ja = {
  settings_users_title: "ユーザー",
  settings_users_desc:
    "ユーザーの集中管理、ロールの割り当て、チーム編成、保留中の招待の確認、アクセス権限の管理を行い、チーム管理を効率化して組織の安全で円滑な運営を確保します。",
  settings_users_add_role: "ロールを追加",
  settings_users_add_team: "チームを追加",
  settings_users_reinvite: "再招待",
  new_user: "新規ユーザー",
  settings_users_account_metrics_no_limit: "無制限",
  account_metrics: "アカウントメトリクス",
  settings_users_new_form_email_address:
    "メールアドレスを入力（複数の場合はカンマ区切り）",
  settings_users_new_form_sharing_rules:
    "共有ルール（チーム選択後に有効化可能）",

  check_payment_order_summary: "注文概要:",
  add_discount_code: "割引コードを追加",

  sharing_rule_is_empty: "共有ルールが空です",

  settings_users_new_form_user_access_configuration: "ユーザーアクセス設定",
};

// Korean (한국어)
export const settings_users_ko = {
  settings_users_title: "사용자",
  settings_users_desc:
    "사용자 중앙 관리, 역할 할당, 팀 구성, 보류 중인 초대 확인 및 접근 권한 관리를 통해 팀 관리를 효율화하고 조직의 안전하고 원활한 운영을 보장합니다.",
  settings_users_add_role: "역할 추가",
  settings_users_add_team: "팀 추가",
  settings_users_reinvite: "재초대",
  new_user: "새 사용자",
  settings_users_account_metrics_no_limit: "제한 없음",
  account_metrics: "계정 메트릭",
  settings_users_new_form_email_address:
    "이메일 주소 입력 (여러 개일 경우 쉼표로 구분)",
  settings_users_new_form_sharing_rules: "공유 규칙 (팀 선택 후 활성화 가능)",

  check_payment_order_summary: "주문 요약:",
  add_discount_code: "할인 코드 추가",

  sharing_rule_is_empty: "공유 규칙이 비어 있습니다",

  settings_users_new_form_user_access_configuration: "사용자 접근 설정",
};

// Hindi (हिन्दी)
export const settings_users_hi = {
  settings_users_title: "उपयोगकर्ता",
  settings_users_desc:
    "केंद्रीकृत उपयोगकर्ता प्रबंधन, भूमिका आवंटन, टीम संगठन, लंबित निमंत्रण देखें और एक्सेस अनुमतियां प्रबंधित करें। अपनी टीम प्रबंधन को अधिक कुशल बनाएं और संगठन के सुरक्षित व सुचारू संचालन को सुनिश्चित करें।",
  settings_users_add_role: "भूमिका जोड़ें",
  settings_users_add_team: "टीम जोड़ें",
  settings_users_reinvite: "पुनः आमंत्रित करें",
  new_user: "नया उपयोगकर्ता",
  settings_users_account_metrics_no_limit: "असीमित",
  account_metrics: "खाता मेट्रिक्स",
  settings_users_new_form_email_address:
    "ईमेल पता दर्ज करें (एकाधिक ईमेल के लिए अल्पविराम से अलग करें)",
  settings_users_new_form_sharing_rules:
    "साझाकरण नियम (टीम चयन के बाद सक्षम किया जा सकता है)",

  check_payment_order_summary: "ऑर्डर सारांश:",
  add_discount_code: "डिस्काउंट कोड जोड़ें",

  sharing_rule_is_empty: "शेयरिंग रूल खाली है",

  settings_users_new_form_user_access_configuration: "उपयोगकर्ता एक्सेस सेटिंग्स",
};
